import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import Config from '@/config/customily'
import ProductsModel from '@/models/ProductModel'

const Customily = {
  getToken: async () => {
    const params = new URLSearchParams()
    params.append('username', Config.username)
    params.append('password', Config.password)
    params.append('grant_type', Config.grantType)
    params.append('client_id', Config.clientId)

    const config: AxiosRequestConfig = {
      method: 'post',
      url: `${Config.apiBaseUrl}/token`,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: params.toString()
    }

    try {
      const response: AxiosResponse = await axios(config)
      return response.data
    } catch (error) {
      throw new Error('All patient counts should be striclty positive')
    }
  },
  getProductsFromTo: async (accessToken: string, queryString: string, from: number, to: number): Promise<ProductsModel[]> => {
    const config: AxiosRequestConfig = {
      method: 'get',
      url: `${Config.apiBaseUrl}/Product/GetProductsFromTo?searchString=${queryString}&from=${from}&to=${to}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }
    const response: AxiosResponse = await axios(config)
    return response.data
  }
}

export default Customily
